import type { BarProps } from './types'

import classNames from 'classnames'

export function Bar({ count, height, title, subtitle, isActive, onClick }: BarProps): JSX.Element {
  return (
    <button
      type='button'
      className={classNames('flex flex-1 flex-col justify-end gap-1', {
        '[&:hover_.bar]:bg-sky-100': !isActive,
        '[&:hover_.bar]:bg-sky-400': isActive
      })}
      onClick={onClick}
    >
      <div className='h-28 flex flex-col justify-end overflow-hidden w-full'>
        <div
          style={{ height: `${Math.max(0.25, height) * 100}%` }}
          className={classNames('bar relative rounded', {
            'bg-gray-100': !isActive,
            'bg-sky-300': isActive
          })}
        >
          <span className='absolute bottom-1.5 left-1/2 -translate-x-1/2 text-xs'>
            {typeof count === 'number' && count > 0 && count}

            {(typeof count !== 'number' || count === 0) && <span className='text-gray-300'>—</span>}
          </span>
        </div>
      </div>
      <div className='flex flex-col items-center justify-start w-full'>
        <span className='font-medium'>{title}</span>
        <span className='text-xs text-gray-600 flex-grow'>{subtitle ?? <span>&nbsp;</span>}</span>
      </div>
    </button>
  )
}
